<template>
  <Modal
    :id="'cmp-promoter-default-new'"
    :loading="!promoterDefaultDetails"
    @cancelled="onCancelClick"
  >
    <template slot="header">{{$t('load_promoter_default')}}</template>
    <template slot="body">
      <v-layout row wrap>
        <v-flex xs4 v-for="(pd, index) of promoterDefaultDetails" :key="index">
          <div class="box-widget selected promoter-default">
            <div class="box-header gray">
              <v-layout justify-center class="box-header--row">
                {{pd.startDate}}
                <input
                  type="radio"
                  @change="e => onRadioChange(e, pd)"
                  :id="pd.startDate+'promoter-default'"
                  name="pd-select"
                  class="pd-radio"
                />
              </v-layout>
            </div>
            <div class="box-body pd-body">
              <div
                class="local-details"
                v-for="ld of pd.localDetails"
                :key="ld.local_detail_id"
              >
           
                <v-layout row wrap class="local_details_type_name">
                  <v-flex xs12>
                    <span>{{ld.local_details_type_name}}</span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs4 v-if="ld.name">{{$t('name')}}</v-flex>
                  <v-flex xs8 class="txtov">{{ld.name}}</v-flex>
                </v-layout>
                <v-layout row wrap v-if="ld.address1 || ld.address2">
                  <v-flex xs4>{{$t('address')}}</v-flex>
                  <v-flex xs8 class="txtov">
                    {{ld.address1}}
                    {{ld.address2}}
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="ld.city">
                  <v-flex xs4>{{$t('city')}}</v-flex>
                  <v-flex xs8 class="txtov">{{ld.city}}</v-flex>
                </v-layout>
                <v-layout row wrap v-if="ld.phone">
                  <v-flex xs4> {{$t('phone')}} </v-flex>
                  <v-flex xs8 class="txtov">{{ld.phone}}</v-flex>
                </v-layout>
                <v-layout row wrap v-if="ld.mobile">
                  <v-flex xs4> {{$t('mobile')}} </v-flex>
                  <v-flex xs8 class="txtov">{{ld.mobile}}</v-flex>
                </v-layout>
                <v-layout row wrap v-if="ld.url">
                  <v-flex xs4> {{$t('url')}} </v-flex>
                  <v-flex xs8 class="txtov">{{ld.url}}</v-flex>
                </v-layout>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </template>
 
    <template slot="options">

      <button class="dt-button s6" @click="onCancelClick">{{$t('cancel')}}</button>
      <button
        class="dt-button s6 v1"
        :class="{
          'disabled': !selectedPromoterDefault
        }"
        :disabled="!selectedPromoterDefault"
        style="min-width: 160px"
        v-if="promoterDefaultDetails && promoterDefaultDetails.length > 0"
        @click="onLoadPromoterDefault"
      >{{$t('load_promoter_default')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { getPromoterDefaultDetails } from '../../models/local-details.model';
import { BookingService } from '../../services/booking-service';


export default {
  components: {
    Modal
  },
  props: ['calendar_date_id'],
  mounted: async function() {
    const showPromoterDef = await BookingService.showPromoterDefaultNew(this.calendar_date_id);
    this.promoterDefault = showPromoterDef.data;
    console.log("Log: this.promoterDefault", this.promoterDefault);
  },
  data: function() {
    return {
      selectedPromoterDefault: null,
      promoterDefault: null,
    };
  },
  computed: {
    calendarDateId: function() {
      return this.$route.params.calendar_date_id;
    },
    promoterDefaultDetails: function() {
      return getPromoterDefaultDetails(this.promoterDefault || {});
    }
  },
  methods: {
    onRadioChange: function(event, promoterDefault) {
      this.selectedPromoterDefault = promoterDefault;
    },
    onLoadPromoterDefault: function(event) {
      if (this.selectedPromoterDefault) {
        this.$emit("loadPromoterDefault", this.selectedPromoterDefault.calendarDateId);
      }
    },
    onCancelClick: function(event) {
      this.$emit("cancelled", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.promoter-default {
  margin: 5px;

  .box-header--name {
    text-align: center;
  }

  .pd-radio {
    margin-left: 8px;
    margin-top: 4px;
  }

  .pd-body {
    overflow-y: auto;
    max-height: calc(100vh - 270px);
  }

  .local-details {
    padding: 5px;

    border-bottom: 1px solid var(--sprt-7);

    .local_details_type_name {
      font-weight: 800;
      padding: 5px 0px;
    }
  }
}
</style>
